import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";

export function useAssetById(assetId?: number) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["assetById", assetId],
    queryFn: async () => {
      if (assetId) return await apiContext.assetApis.getAssetById(assetId);
    },
  });
}
